import { MaxBrainScheduledStreamContent } from '../models/scheduled-stream-content.model';

export class AddScheduledStreamContents {
    static readonly type = '[ScheduledStreamContent] AddScheduledStreamContents';

    constructor(public payload: MaxBrainScheduledStreamContent[]) {}
}
